import { TelegramIcon, WhatsappIcon } from "shared/ui";
import { TwoFactorProviderConfig } from "./types";

export const TWO_FACTOR_PROVIDERS: TwoFactorProviderConfig[] = [
  {
    provider: "telegram",
    label: "Telegram 2FA",
    Icon: TelegramIcon,
    available: true,
  },
  {
    provider: "whatsapp",
    label: "WhatsApp 2FA",
    Icon: WhatsappIcon,
    available: true,
  },
];
